import Frame from "./Frame"
import SideMenu from "../components/SideMenu"
import { Outlet } from "react-router-dom"

export default function F1() {
    return (
        <>
            <Frame>
                <SideMenu />
                <Outlet />
            </Frame>
        </>
    )
}